module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('v-nav-bar'), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._t("default")], 2)])]), _vm._v(" "), _c('v-footer')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-02a6e400"}!./src/app/layouts/default/default.html
// module id = 455
// module chunks = 1